module.exports = __webpack_public_path__ + "img/js.2c357005.svg";